'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FullDoesNotExist = exports.retrieveOrganizationFull = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var retrieveOrganizationFull = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var openrest = _ref2.openrest,
            facebookPageId = _ref2.facebookPageId,
            forceId = _ref2.forceId,
            webserver = _ref2.webserver,
            fetch = _ref2.fetch,
            _ref2$metasiteId = _ref2.metasiteId,
            metasiteId = _ref2$metasiteId === undefined ? '' : _ref2$metasiteId,
            instanceId = _ref2.instanceId,
            appId = _ref2.appId,
            originInstanceId = _ref2.originInstanceId,
            language = _ref2.language,
            restClient = _ref2.restClient,
            mappingClient = _ref2.mappingClient,
            instance = _ref2.instance,
            locationId = _ref2.locationId;
        var result;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        result = null;

                        // Is this a facebook page?

                        _context.next = 3;
                        return _getFullByFacebookPageId({ mappingClient: mappingClient, restClient: restClient, facebookPageId: facebookPageId });

                    case 3:
                        result = _context.sent;

                        if (!result) {
                            _context.next = 6;
                            break;
                        }

                        return _context.abrupt('return', result);

                    case 6:
                        _context.next = 8;
                        return _getFullByForceId({ restClient: restClient, forceId: forceId });

                    case 8:
                        result = _context.sent;

                        if (!result) {
                            _context.next = 11;
                            break;
                        }

                        return _context.abrupt('return', result);

                    case 11:
                        _context.next = 13;
                        return _getFullByWebServer({ webserver: webserver });

                    case 13:
                        result = _context.sent;

                        if (!result) {
                            _context.next = 16;
                            break;
                        }

                        return _context.abrupt('return', result);

                    case 16:
                        if (!instanceId) {
                            _context.next = 22;
                            break;
                        }

                        _context.next = 19;
                        return _getFullFromRemoteByInstanceId({ fetch: fetch, metasiteId: metasiteId, instanceId: instanceId, appId: appId, instance: instance, locationId: locationId });

                    case 19:
                        result = _context.sent;

                        if (!result) {
                            _context.next = 22;
                            break;
                        }

                        return _context.abrupt('return', result);

                    case 22:
                        if (!originInstanceId) {
                            _context.next = 28;
                            break;
                        }

                        _context.next = 25;
                        return _getFullFromRemoteByInstanceId({ fetch: fetch, metasiteId: metasiteId, instanceId: originInstanceId, appId: appId, instance: instance, locationId: locationId });

                    case 25:
                        result = _context.sent;

                        if (!result) {
                            _context.next = 28;
                            break;
                        }

                        return _context.abrupt('return', result);

                    case 28:
                        _context.next = 30;
                        return _getFullFromDefaultByLanguage({ mappingClient: mappingClient, restClient: restClient, language: language });

                    case 30:
                        result = _context.sent;
                        return _context.abrupt('return', result);

                    case 32:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function retrieveOrganizationFull(_x) {
        return _ref.apply(this, arguments);
    };
}();

/**
 * Checks if the action contains a facebookPageId, and if so returns a restaurant full
 * based on that id.
 */
var _getFullByFacebookPageId = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref4) {
        var mappingClient = _ref4.mappingClient,
            restClient = _ref4.restClient,
            facebookPageId = _ref4.facebookPageId;

        var _ref5, organizationId, full;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        if (!facebookPageId) {
                            _context2.next = 15;
                            break;
                        }

                        _context2.prev = 1;
                        _context2.next = 4;
                        return mappingClient('/facebook/' + facebookPageId);

                    case 4:
                        _ref5 = _context2.sent;
                        organizationId = _ref5.organizationId;
                        _context2.next = 8;
                        return restClient('/organizations/' + organizationId + '/full');

                    case 8:
                        full = _context2.sent;
                        return _context2.abrupt('return', { full: full });

                    case 12:
                        _context2.prev = 12;
                        _context2.t0 = _context2['catch'](1);
                        throw new FullDoesNotExist();

                    case 15:
                        return _context2.abrupt('return', null);

                    case 16:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this, [[1, 12]]);
    }));

    return function _getFullByFacebookPageId(_x2) {
        return _ref3.apply(this, arguments);
    };
}();

/**
 * Checks if the action contains a forceId. If so, returns a restaurant full based on
 * that force id.
 */


var _getFullByForceId = function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref7) {
        var restClient = _ref7.restClient,
            forceId = _ref7.forceId;
        var full;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        if (!forceId) {
                            _context3.next = 11;
                            break;
                        }

                        _context3.prev = 1;
                        _context3.next = 4;
                        return restClient('/organizations/' + forceId + '/full');

                    case 4:
                        full = _context3.sent;
                        return _context3.abrupt('return', { full: full });

                    case 8:
                        _context3.prev = 8;
                        _context3.t0 = _context3['catch'](1);
                        throw new FullDoesNotExist();

                    case 11:
                        return _context3.abrupt('return', null);

                    case 12:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this, [[1, 8]]);
    }));

    return function _getFullByForceId(_x3) {
        return _ref6.apply(this, arguments);
    };
}();

/**
 * Checks if we have been preloaded with full data from the webserver. If so, returns it.
 */


var _getFullByWebServer = function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref9) {
        var webserver = _ref9.webserver;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        if (!webserver) {
                            _context4.next = 11;
                            break;
                        }

                        if (!(webserver.organizationFull && !webserver.full)) {
                            _context4.next = 5;
                            break;
                        }

                        return _context4.abrupt('return', { originFull: webserver.organizationFull });

                    case 5:
                        if (!webserver.full) {
                            _context4.next = 11;
                            break;
                        }

                        if (!webserver.fullFromSite) {
                            _context4.next = 10;
                            break;
                        }

                        return _context4.abrupt('return', { full: webserver.full });

                    case 10:
                        return _context4.abrupt('return', { originFull: webserver.full });

                    case 11:
                        return _context4.abrupt('return', null);

                    case 12:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function _getFullByWebServer(_x4) {
        return _ref8.apply(this, arguments);
    };
}();

/**
 * Retreives restaurant information based on instanceId, and original instanceId.
 */


var _getFullFromRemoteByInstanceId = function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(_ref11) {
        var fetch = _ref11.fetch,
            metasiteId = _ref11.metasiteId,
            instanceId = _ref11.instanceId,
            appId = _ref11.appId,
            instance = _ref11.instance,
            locationId = _ref11.locationId;
        var url, remote;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.prev = 0;
                        url = 'https://apps.wixrestaurants.com/organization/get/?instanceId=' + instanceId + '&appId=' + appId;


                        if (metasiteId) {
                            url += '&metasiteId=' + metasiteId;
                        }

                        if (instance) {
                            url += '&instance=' + instance;
                        }

                        if (locationId) {
                            url += '&locationId=' + locationId;
                        }

                        _context5.next = 7;
                        return fetch(url).then(function (r) {
                            return r.json();
                        });

                    case 7:
                        remote = _context5.sent;

                        if (!(!remote || !remote.value)) {
                            _context5.next = 12;
                            break;
                        }

                        return _context5.abrupt('return', null);

                    case 12:
                        if (!remote.fromSite) {
                            _context5.next = 16;
                            break;
                        }

                        return _context5.abrupt('return', { full: remote.value });

                    case 16:
                        return _context5.abrupt('return', { originFull: remote.value });

                    case 17:
                        _context5.next = 23;
                        break;

                    case 19:
                        _context5.prev = 19;
                        _context5.t0 = _context5['catch'](0);

                        console.log(_context5.t0);
                        throw new FullDoesNotExist();

                    case 23:
                        return _context5.abrupt('return', null);

                    case 24:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this, [[0, 19]]);
    }));

    return function _getFullFromRemoteByInstanceId(_x5) {
        return _ref10.apply(this, arguments);
    };
}();

var _getFullFromDefaultByLanguage = function () {
    var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(_ref13) {
        var mappingClient = _ref13.mappingClient,
            restClient = _ref13.restClient,
            language = _ref13.language;

        var requests, instanceId, _ref14, organizationId, full;

        return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        requests = [];
                        instanceId = getDefaultInstanceId(language);
                        _context6.next = 4;
                        return mappingClient('/instances/' + instanceId);

                    case 4:
                        _ref14 = _context6.sent;
                        organizationId = _ref14.organizationId;
                        _context6.next = 8;
                        return restClient('/organizations/' + organizationId + '/full');

                    case 8:
                        full = _context6.sent;
                        return _context6.abrupt('return', { originFull: full });

                    case 10:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function _getFullFromDefaultByLanguage(_x6) {
        return _ref12.apply(this, arguments);
    };
}();

/**
 * Return an instance id for the default menu to display if none exist.
 */


exports.getDefaultInstanceId = getDefaultInstanceId;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullDoesNotExist = function (_Error) {
    (0, _inherits3.default)(FullDoesNotExist, _Error);

    function FullDoesNotExist(p) {
        (0, _classCallCheck3.default)(this, FullDoesNotExist);
        return (0, _possibleConstructorReturn3.default)(this, (FullDoesNotExist.__proto__ || (0, _getPrototypeOf2.default)(FullDoesNotExist)).call(this, p));
    }

    return FullDoesNotExist;
}(Error);

exports.retrieveOrganizationFull = retrieveOrganizationFull;
exports.FullDoesNotExist = FullDoesNotExist;
function getDefaultInstanceId(uxLanguage) {
    switch (uxLanguage) {
        case 'pt':
            return '8b4b3788-fe3b-4a18-9f66-d8511619f3d8';

        case 'ru':
            return '134a723c-7688-4ff0-ba95-d95bb8c7d16d';

        case 'ko':
            return 'a4a59b58-3afa-422b-8123-1984ddb2d1db';

        case 'de':
            return '98b295c5-9aff-4225-8649-12f878c24df1';

        case 'tr':
            return 'e4d96b9a-88e3-4047-af83-6b5be0af05c4';

        case 'no':
            return 'f3bade9a-4e54-4b9b-9926-f379828191b4';

        case 'da':
            return '6261eac0-3f3a-472e-84f1-d3ca67e348cb';

        case 'pl':
            return '25347fe6-27c3-4663-ac2b-9182e1b10898';

        case 'nl':
            return '8fc7ffc0-5a50-4177-8a6f-95233d5807a3';

        case 'jp':
            return 'd7156318-5caa-47c7-8834-e3d1284c1ea6';

        case 'sv':
            return 'a7f52b3a-3b39-45b6-aa1d-129f2b969497';

        case 'it':
            return 'bec0af05-6d96-40c7-8fd1-a5609caecae0';

        case 'es':
            return '01a48c8d-77f6-427a-a0ee-928f519a0099';

        case 'fr':
            return 'e9cb49b7-36bd-4fc0-885c-55571a5cb1e9';

        default:
            return 'c28faa57-83f9-44db-8ce5-7273bd6fca53';
    }
}